// extracted by mini-css-extract-plugin
export default {"label":"PunchupToggle_label__Tk1CW","input":"PunchupToggle_input__YdbEI","track":"PunchupToggle_track__1PWSw","knob":"PunchupToggle_knob__r7mvb"};